import { AppealStatus, TServiceOffer } from 'feature/appeals/type'

import style from './OfferPriceBlock.module.scss'
import { useOfferPriceBlock } from './useOfferPriceBlock'
import { formatPriceInRubles } from 'helpers/formatPrice'

type TOfferPriceBlock = {
  offer: TServiceOffer
  appealStatus?: AppealStatus | null
}

export const OfferPriceBlock = ({ offer, appealStatus }: TOfferPriceBlock) => {
  const { unpaidPayment, stage } = useOfferPriceBlock(offer, appealStatus)

  const firstPaymentAmount = offer.payments[0]?.amount ?? 0

  return (
    <div className={style.priceWrapper}>
      <div className={style.price}>
        <span className='default-text'>Итого</span>
        <span className='h2'>{formatPriceInRubles(offer.price)}</span>
      </div>

      {/* Стадия 1: первая оплата ещё не прошла */}
      {stage === 'AWAITING_FIRST_PAYMENT' && (
        <div className={style.price}>
          <span className='default-text'>Предоплата</span>
          <span className='h2'>{formatPriceInRubles(firstPaymentAmount)}</span>
        </div>
      )}

      {/* Стадии 2 и 3: первая оплата прошла */}
      {(stage === 'AWAITING_SECOND_LINK' ||
        stage === 'AWAITING_SECOND_PAYMENT') && (
        <>
          <div className={style.price}>
            <span className='default-text'>Оплачено</span>
            <span className='h2'>
              {formatPriceInRubles(firstPaymentAmount)}
            </span>
          </div>
          {unpaidPayment && (
            <div className={style.price}>
              <span className='default-text'>Осталось оплатить</span>
              <span className='h2'>
                {formatPriceInRubles(unpaidPayment.amount)}
              </span>
            </div>
          )}
        </>
      )}
    </div>
  )
}
